module.exports = __webpack_public_path__ + "img/liv_wake.9f124614.png";